import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NumberToArabicService {

    private ones = [
        "صفر", "واحد", "اثنان", "ثلاثة", "أربعة", "خمسة",
        "ستة", "سبعة", "ثمانية", "تسعة"
    ];

    private tens = [
        "", "عشرة", "عشرون", "ثلاثون", "أربعون", "خمسون",
        "ستون", "سبعون", "ثمانون", "تسعون"
    ];

    private teens = [
        "عشرة", "أحد عشر", "اثنا عشر", "ثلاثة عشر", "أربعة عشر",
        "خمسة عشر", "ستة عشر", "سبعة عشر", "ثمانية عشر", "تسعة عشر"
    ];

    private hundreds = [
        "", "مائة", "مائتان", "ثلاثمائة", "أربعمائة", "خمسمائة",
        "ستمائة", "سبعمائة", "ثمانمائة", "تسعمائة"
    ];

    constructor() {}

    numberToArabicWords(num: number): string {
        if (num === 0) return this.ones[0];

        if (num < 10) return this.ones[num];
        if (num < 20) return this.teens[num - 10];

        if (num < 100) {
            const one = num % 10;
            const ten = Math.floor(num / 10);
            return one === 0 ? this.tens[ten] : `${this.ones[one]} و ${this.tens[ten]}`;
        }

        if (num < 1000) {
            const hundred = Math.floor(num / 100);
            const rest = num % 100;
            return rest === 0 ? this.hundreds[hundred] : `${this.hundreds[hundred]} و ${this.numberToArabicWords(rest)}`;
        }

        if (num < 1_000_000) {
            const thousand = Math.floor(num / 1000);
            const rest = num % 1000;

            let thousandWord =
                thousand === 1 ? "ألف" :
                    thousand === 2 ? "ألفان" :
                        thousand < 10 ? this.ones[thousand] + " آلاف" :
                            this.numberToArabicWords(thousand) + " ألف";

            return rest === 0 ? thousandWord : `${thousandWord} و ${this.numberToArabicWords(rest)}`;
        }

        if (num < 1_000_000_000) { // millions
            const million = Math.floor(num / 1_000_000);
            const rest = num % 1_000_000;

            let millionWord =
                million === 1 ? "مليون" :
                    million === 2 ? "مليونان" :
                        million < 10 ? this.ones[million] + " ملايين" :
                            this.numberToArabicWords(million) + " مليون";

            return rest === 0 ? millionWord : `${millionWord} و ${this.numberToArabicWords(rest)}`;
        }

        return "عدد كبير";
    }

    /** Convertit un montant Dinar + Centimes */
    amountToArabic(amount: number): string {
        const integer = Math.floor(amount);
        const decimal = Math.round((amount % 1) * 100);

        const mainText = `${this.numberToArabicWords(integer)} دينار`;

        if (decimal > 0) {
            return `${mainText} و ${this.numberToArabicWords(decimal)} سنتيم`;
        }

        return mainText;
    }
}
